/**
 * Hook for orchestrating packing Redux state and actions
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
// Selectors
selectShipmentData, selectShipmentId, selectCurrentSubscreen, selectPackageContentBySeqId, selectPackageOrderItemsBySeqId, selectPackageSerialNumbersBySeqId, selectPackageMetadataBySeqId, selectBulkPackMode, selectScanThroughPack, selectContainerId, selectBoxTypes, selectWeightUoMs, selectShippingMethods, selectCountriesList, selectStatesList, selectShipmentList, selectShipmentListPagination, selectAttachmentList, selectShipmentStatusList, selectLoadingState, selectErrorState, selectIsAnyLoading, selectShipmentItems, selectShipmentPackages, selectProductSkuUpcList, selectKitComponentProducts, selectPackageRouteSegments, selectShipmentRouteSegments, selectToContactInfo, selectHasAllLabels, selectDestContactMechValid, selectShipmentStatus, selectUserPreferences, selectShipmentItemSourceList, selectAssetReservationList, selectAssetLotList, selectFacilityLocationList, selectShipmentLocationTypeList, selectShipmentStatusDescription, selectItemAssets, selectShipmentContainerList, selectContainerLinkedPackageSeqIds, selectQzHostname, selectIsQzConnected, selectIsQzHostnameChecked, 
// Actions
setCurrentSubscreen, setContainerId, setBulkPackMode, setScanThroughPack, clearShipmentData, clearErrors, resetPackingState, 
// Thunks
fetchShipmentDetails, fetchBoxTypes, fetchWeightUoMs, fetchShippingMethods, fetchShipmentList, fetchCountries, fetchStates, fetchUserPreferences, initializePacking, fetchPackageWeight, selectShipmentItemDetailList, selectToContactEmailInfo, selectToTelecomNumberInfo, selectFromContactInfo, selectToPartyDetail, selectShipmentTypeMethods, selectContainerPackerBySeqId, selectContainerTypeList } from '../../redux/packing';
export var usePackingState = function () {
    var dispatch = useDispatch();
    // Selectors
    var shipmentData = useSelector(selectShipmentData);
    var shipmentId = useSelector(selectShipmentId);
    var currentSubscreen = useSelector(selectCurrentSubscreen);
    var packageContentBySeqId = useSelector(selectPackageContentBySeqId);
    var packageOrderItemsBySeqId = useSelector(selectPackageOrderItemsBySeqId);
    var containerPackerById = useSelector(selectContainerPackerBySeqId);
    var packageSerialNumbersBySeqId = useSelector(selectPackageSerialNumbersBySeqId);
    var shipmentPackageList = useSelector(selectShipmentPackages);
    var packageMetadataBySeqId = useSelector(selectPackageMetadataBySeqId);
    var bulkPackMode = useSelector(selectBulkPackMode);
    var scanThroughPack = useSelector(selectScanThroughPack);
    var containerId = useSelector(selectContainerId);
    var boxTypes = useSelector(selectBoxTypes);
    var shipmentTypeMethods = useSelector(selectShipmentTypeMethods);
    var weightUoMs = useSelector(selectWeightUoMs);
    var shippingMethods = useSelector(selectShippingMethods);
    var countriesList = useSelector(selectCountriesList);
    var statesList = useSelector(selectStatesList);
    var shipmentList = useSelector(selectShipmentList);
    var shipmentListPagination = useSelector(selectShipmentListPagination);
    var attachmentList = useSelector(selectAttachmentList);
    var shipmentStatusList = useSelector(selectShipmentStatusList);
    var loading = useSelector(selectLoadingState);
    var errors = useSelector(selectErrorState);
    var isAnyLoading = useSelector(selectIsAnyLoading);
    var shipmentItems = useSelector(selectShipmentItems);
    var shipmentPackages = useSelector(selectShipmentPackages);
    var productSkuUpcList = useSelector(selectProductSkuUpcList);
    var kitComponentProducts = useSelector(selectKitComponentProducts);
    var packageRouteSegments = useSelector(selectPackageRouteSegments);
    var shipmentRouteSegments = useSelector(selectShipmentRouteSegments);
    var fromContactInfo = useSelector(selectFromContactInfo);
    var toPartyDetail = useSelector(selectToPartyDetail);
    var toContactInfo = useSelector(selectToContactInfo);
    var toContactEmailInfo = useSelector(selectToContactEmailInfo);
    var toTelecomNumberInfo = useSelector(selectToTelecomNumberInfo);
    var hasAllLabels = useSelector(selectHasAllLabels);
    var destContactMechValid = useSelector(selectDestContactMechValid);
    var shipmentStatus = useSelector(selectShipmentStatus);
    var shipmentStatusDescription = useSelector(selectShipmentStatusDescription);
    var userPreferences = useSelector(selectUserPreferences);
    var shipmentItemSourceList = useSelector(selectShipmentItemSourceList);
    var shipmentItemDetailList = useSelector(selectShipmentItemDetailList);
    var assetReservationList = useSelector(selectAssetReservationList);
    var assetLotList = useSelector(selectAssetLotList);
    var facilityLocationList = useSelector(selectFacilityLocationList);
    var shipmentLocationTypeList = useSelector(selectShipmentLocationTypeList);
    var itemAssets = useSelector(selectItemAssets);
    var qzHostname = useSelector(selectQzHostname);
    var isQzConnected = useSelector(selectIsQzConnected);
    var isQzHostnameChecked = useSelector(selectIsQzHostnameChecked);
    var shipmentContainerList = useSelector(selectShipmentContainerList);
    var containerLinkedPackageSeqIds = useSelector(selectContainerLinkedPackageSeqIds);
    var containerTypeList = useSelector(selectContainerTypeList);
    // Actions
    var navigateToSubscreen = useCallback(function (subscreen) {
        dispatch(setCurrentSubscreen(subscreen));
    }, [dispatch]);
    var setContainer = useCallback(function (id) {
        dispatch(setContainerId(id));
    }, [dispatch]);
    var toggleBulkPackMode = useCallback(function (enabled) {
        dispatch(setBulkPackMode(enabled));
    }, [dispatch]);
    var toggleScanThroughPack = useCallback(function (enabled) {
        dispatch(setScanThroughPack(enabled));
    }, [dispatch]);
    var clearShipment = useCallback(function () {
        dispatch(clearShipmentData());
    }, [dispatch]);
    var clearAllErrors = useCallback(function () {
        dispatch(clearErrors());
    }, [dispatch]);
    var resetState = useCallback(function () {
        dispatch(resetPackingState());
    }, [dispatch]);
    // Data fetching
    var loadShipmentDetails = useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchShipmentDetails({ shipmentId: id }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var loadBoxTypes = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchBoxTypes())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var loadWeightUoMs = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchWeightUoMs())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var loadShippingMethods = useCallback(function (id, opts) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchShippingMethods({ shipmentId: id, getRates: opts === null || opts === void 0 ? void 0 : opts.getRates }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var loadShipmentList = useCallback(function (id, pageIndex) {
        if (pageIndex === void 0) { pageIndex = 0; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(fetchShipmentList({ containerId: id, pageIndex: pageIndex }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }, [dispatch]);
    var loadCountries = useCallback(function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchCountries({ shipmentId: id }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var loadStates = useCallback(function (id, countryGeoId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchStates({ shipmentId: id, countryGeoId: countryGeoId }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var loadUserPreferences = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchUserPreferences())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var loadInitialData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all([dispatch(initializePacking())])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch]);
    var loadPackageWeight = useCallback(function (shipmentIdParam, shipmentPackageSeqId) { return __awaiter(void 0, void 0, Promise, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(fetchPackageWeight({
                        shipmentId: shipmentIdParam,
                        shipmentPackageSeqId: shipmentPackageSeqId
                    }))];
                case 1:
                    result = _a.sent();
                    if (fetchPackageWeight.fulfilled.match(result)) {
                        return [2 /*return*/, result.payload];
                    }
                    return [2 /*return*/, null];
            }
        });
    }); }, [dispatch]);
    return {
        // State
        shipmentData: shipmentData,
        shipmentId: shipmentId,
        currentSubscreen: currentSubscreen,
        packageContentBySeqId: packageContentBySeqId,
        packageOrderItemsBySeqId: packageOrderItemsBySeqId,
        packageSerialNumbersBySeqId: packageSerialNumbersBySeqId,
        containerPackerById: containerPackerById,
        shipmentPackageList: shipmentPackageList,
        packageMetadataBySeqId: packageMetadataBySeqId,
        bulkPackMode: bulkPackMode,
        scanThroughPack: scanThroughPack,
        containerId: containerId,
        boxTypes: boxTypes,
        shipmentTypeMethods: shipmentTypeMethods,
        weightUoMs: weightUoMs,
        shippingMethods: shippingMethods,
        countriesList: countriesList,
        statesList: statesList,
        shipmentList: shipmentList,
        shipmentListPagination: shipmentListPagination,
        attachmentList: attachmentList,
        shipmentStatusList: shipmentStatusList,
        loading: loading,
        errors: errors,
        isAnyLoading: isAnyLoading,
        shipmentItems: shipmentItems,
        shipmentPackages: shipmentPackages,
        productSkuUpcList: productSkuUpcList,
        kitComponentProducts: kitComponentProducts,
        packageRouteSegments: packageRouteSegments,
        shipmentRouteSegments: shipmentRouteSegments,
        fromContactInfo: fromContactInfo,
        toPartyDetail: toPartyDetail,
        toContactInfo: toContactInfo,
        toContactEmailInfo: toContactEmailInfo,
        toTelecomNumberInfo: toTelecomNumberInfo,
        hasAllLabels: hasAllLabels,
        destContactMechValid: destContactMechValid,
        shipmentStatus: shipmentStatus,
        shipmentStatusDescription: shipmentStatusDescription,
        userPreferences: userPreferences,
        shipmentItemSourceList: shipmentItemSourceList,
        shipmentItemDetailList: shipmentItemDetailList,
        assetReservationList: assetReservationList,
        assetLotList: assetLotList,
        facilityLocationList: facilityLocationList,
        shipmentLocationTypeList: shipmentLocationTypeList,
        itemAssets: itemAssets,
        qzHostname: qzHostname,
        isQzConnected: isQzConnected,
        isQzHostnameChecked: isQzHostnameChecked,
        shipmentContainerList: shipmentContainerList,
        containerLinkedPackageSeqIds: containerLinkedPackageSeqIds,
        containerTypeList: containerTypeList,
        // Actions
        navigateToSubscreen: navigateToSubscreen,
        setContainer: setContainer,
        toggleBulkPackMode: toggleBulkPackMode,
        toggleScanThroughPack: toggleScanThroughPack,
        clearShipment: clearShipment,
        clearAllErrors: clearAllErrors,
        resetState: resetState,
        // Data fetching
        loadShipmentDetails: loadShipmentDetails,
        loadBoxTypes: loadBoxTypes,
        loadWeightUoMs: loadWeightUoMs,
        loadShippingMethods: loadShippingMethods,
        loadShipmentList: loadShipmentList,
        loadCountries: loadCountries,
        loadStates: loadStates,
        loadUserPreferences: loadUserPreferences,
        loadInitialData: loadInitialData,
        loadPackageWeight: loadPackageWeight
    };
};
export default usePackingState;
